export default __webpack_public_path__ + "static/media/indianTelevision.08c20b72.svg";